import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UPDATE } from '@ngrx/store';
import { BehaviorSubject, forkJoin, pipe } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { FolderDataSource } from 'src/app/acl-data/folder/folder.datasource';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { deepCopy } from 'src/app/acl-data/general/generic.function';
import { I1FilenetServices } from 'src/app/acl-data/i1-filenet-services.service';
import { PopupConfirmationComponent } from 'src/app/modal/popup-confirmation/popup-confirmation.component';

export const tableTransitions = trigger('tableTransition', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate('200ms ease-in-out', style({ transform: 'translateX(0)' }))
  ]),
  transition(':leave', [
    animate('200ms ease-in-out', style({ transform: 'translateX(-100%)' }))
  ])
]);

@Component({
  selector: 'app-access-type-popup',
  templateUrl: './access-type-popup.component.html',
  styleUrls: ['./access-type-popup.component.scss'],
  animations: [tableTransitions]
})
export class AccessTypePopupComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('chkBox', {static: false}) cb: MatCheckbox;
  @Input() accessType: string = '';
  @Input() user: string;
  @Input() libraryIDs: string[] = [];

  currentTable = 'Library';
  permissions: string;
  permissionsDetail: string;
  location: string
  tables = ['Library', 'Territory', 'Category'];

  pageSizeOptions: number[] = [5, 10, 25, 50, 100];
  private isSelected: boolean = false;

  progressMessage = "";

  dontShow = false;


  libraryInfo: Folder[]
  libraryData: MatTableDataSource<Folder & { checked?: boolean }>;
  categoryInfo: Folder[];
  categoryData: MatTableDataSource<Folder & { checked?: boolean, rowDisabled?: boolean }>;
  territoryInfo: Folder[];
  territoryData: MatTableDataSource<Folder & { checked?: boolean, rowDisabled?: boolean }>;

  libraryChanges: (Folder & { checked?: boolean })[] = [];
  categoryChanges: (Folder & { checked?: boolean })[] = [];
  territoryChanges: (Folder & { checked?: boolean })[] = [];

  parentId: string;
  loading$ = this.folderService.loading$
  loadingSave$ = new BehaviorSubject<boolean>(false);
  catFolderId: any;
  terFolderId: any;

  allSelected: boolean = false;
  previousRowState: any;
  previousData: any;

  currentLibraryState: (Folder & { checked?: boolean })[] = [];
  currentTeritoryState: (Folder & { checked?: boolean })[] = [];
  currentCategoryState: (Folder & { checked?: boolean })[] = [];
  skipFolder: boolean;




  constructor(public dialogRef: MatDialogRef<AccessTypePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private folderService: FolderService,
    private dialog: MatDialog,
    private i1FilenetServices: I1FilenetServices,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef) {


  }



  ngOnInit(): void {

    this.getInitialData()



    this.permissions = 'Library Permissions'
    this.permissionsDetail = `Please select which libraries you want to grant ${this.accessType} permissions.\n
    This will grant permissions to all sub-folders`;

  }



  async getInitialData(pageSizeReset: boolean = false, getAll: boolean = false) {

    if(this.territoryData){
      this.territoryData.data = []

    }
    
    this.skipFolder = false;
    this.location = '';
    if (pageSizeReset) {
      this.libraryData.paginator.pageSize = await this.pageSizeOptions[0]
    }


    let ids;
    const startIndex = this.libraryData ? this.libraryData.paginator.pageIndex * this.libraryData.paginator.pageSize : 0;
    const endIndex = this.libraryData ? startIndex + this.libraryData.paginator.pageSize : 5;

    if (getAll) {
      ids = this.libraryIDs
    } else {
      ids = this.libraryIDs.slice(startIndex, endIndex);
    }

    let libraryInfo: Folder[] = (await this.folderService.getByIdsForManageUser(this.data.objectStore, ids, true).toPromise()).map(
      v => {
        let checked;
        if (this.accessType === 'READER') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Read') ? true : false;
        } else if (this.accessType === 'INITIATOR') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Initiator') ? true : false;
        }


        this.parentId = v.parentID;
        return {
          ...v,
          checked
        };
      },
    )




    if (!this.libraryData) {
      this.libraryData = new MatTableDataSource<Folder>(libraryInfo);
      this.libraryData.paginator = this.paginator
      this.libraryData.sort = this.sort
    } else {
      libraryInfo.forEach(updatedItem => {
        const existingItemIndex = this.libraryData.data.findIndex(existingItem => existingItem.id === updatedItem.id);
      
        if (existingItemIndex !== -1) {
          // If the item exists in libraryData, update the 'checked' property from the updated item
          this.libraryData.data[existingItemIndex].checked = updatedItem['checked'];
        } else {
          // If the item does not exist in libraryData, add the updated item to the libraryData
          this.libraryData.data.push(updatedItem);
        }
      });
      
      // Remove duplicates based on the 'id' property
      this.libraryData.data = this.libraryData.data.filter(
        (item, index, self) => index === self.findIndex(existingItem => existingItem.id === item.id)
      );
    }


    if(this.libraryChanges){
      this.libraryData.data.forEach(x=>{
        const found = this.libraryChanges.find(y=> y.id == x.id)

        if(found){
          x.checked = found.checked
        }
      })
    }

    this.currentLibraryState = deepCopy(this.libraryData.data)


    //update the paginator to correct size, need to use await as it does not update correctly on the UI (due to being an async method)
    this.libraryData.paginator.length = await this.libraryIDs.length

    this.cdr.detectChanges()


  }

  async getTerritoryData(folderId: any, pageSizeReset: boolean = false) {


    this.location = this.libraryData.data.find(x => x.id == folderId).properties.find(x => x.name == 'FolderName').value

    this.terFolderId = await folderId;
    let territoryIDs = (await this.folderService.getByID(this.data.objectStore, folderId).toPromise()).subFolders

    let isTerritory = (await this.folderService.getByID(this.data.objectStore, territoryIDs[0]).toPromise()).propertiesObj.ClassDescription

if(isTerritory == 'CategoryFolder'){
  this.changeTable('Category', folderId)
  this.skipFolder = true
  return;
}

    let territoryInfo = (await this.folderService.getByIdsForManageUser(this.data.objectStore, territoryIDs, true).toPromise()).map(
      v => {
          //Check if it is 

        let checked;
        if (this.accessType === 'READER') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Read') ? true : false;
        } else if (this.accessType === 'INITIATOR') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Initiator') ? true : false;
        }

        this.parentId = v.parentID;

        return {
          ...v,
          checked
        };
      }
    )

    this.territoryData = new MatTableDataSource<Folder & { checked?: boolean }>(territoryInfo);
    this.territoryData.paginator = this.paginator
    this.territoryData.sort = this.sort


    this.currentTeritoryState = deepCopy(this.territoryData.data)

    if (pageSizeReset) {
      this.territoryData.paginator.pageSize = await this.pageSizeOptions[0]
    }


    this.cdr.detectChanges()

  }





  async getCategoryData(folderId: any, pageSizeReset: boolean = false) {

    if(this.territoryData){
      if(this.territoryData.data.length > 0){
      this.location += ' -> ' + this.territoryData.data.find(x => x.id == folderId).properties[4].value
      }
    }

    this.catFolderId = await folderId;
    let categoryIDs = (await this.folderService.getByID(this.data.objectStore, folderId).toPromise()).subFolders


    let categoryInfo: Folder[] = (await this.folderService.getByIdsForManageUser(this.data.objectStore, categoryIDs, true).toPromise()).map(
      v => {
        let checked;
        if (this.accessType === 'READER') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Read') ? true : false;
        } else if (this.accessType === 'INITIATOR') {
          checked = v.acl.find(x => x.name == this.user && x.level === 'Initiator') ? true : false;
        }

        return {
          ...v,
          checked
        };
      }
    )

    this.categoryData = new MatTableDataSource<Folder>(categoryInfo);
    this.categoryData.paginator = this.paginator
    this.categoryData.sort = this.sort

    this.currentCategoryState = deepCopy(this.categoryData.data)
    if (pageSizeReset) {
      this.categoryData.paginator.pageSize = await this.pageSizeOptions[0]
    }


    this.cdr.detectChanges()

  }



  async selectAll() {

    let dialogRef;
    let allSelected = this.isAllSelected();

    if(this.currentTable === 'Library'){
      dialogRef = this.dialog.open(PopupConfirmationComponent, {
        data: {
          title: 'Grant Access To All',
          description: 'Please note that granting access to all will grant permissions to all libraries and will overwrite any existing permissions.\n'+
                        'This will also take some time to complete.\n\n'+
                        'Would you like to continue?',
          option1: 'Yes',
          option2: 'No'
        },

      });
    }
    else if (!allSelected) {
      dialogRef = this.dialog.open(PopupConfirmationComponent, {
        data: {
          title: 'Select All',
          description: `Please note that selecting all will have to fetch all the ${this.currentTable} folders and may take some time.\nWould you like to continue?`,
          option1: 'Yes',
          option2: 'No'
        },

      });
    } else {
      dialogRef = this.dialog.open(PopupConfirmationComponent, {
        data: {
          title: 'Deselect All',
          description: 'Please note that de-selecting all will have to fetch all the Libraries and may take some time.\nWould you like to continue?',
          option1: 'Yes',
          option2: 'No'
        },

      });
    }

    dialogRef.afterClosed().subscribe(async x => {

      if (x.toLowerCase() == "yes") {
        switch (this.currentTable) {
          case 'Library': {

            await this.getInitialData(false, true);
            this.libraryData.data.forEach(async row => {

              if(row.properties[4].value == 'Transactions'){
                return;
              }
              
              if(!row.checked){
                row.checked = true;
              }
              this.onSelectAllStateChanged(row)
            });
            break;

          }

          case 'Category': {

            this.categoryData.data.forEach(async row => {
              row.checked = !allSelected
              this.onSelectAllStateChanged(row)
            });

            break;

          }


          case 'Territory': {
            this.territoryData.data.forEach(async row => {
              row.checked = !allSelected

              this.onSelectAllStateChanged(row)
            });
            break;
          }
        }
      }
      allSelected = this.isAllSelected()

      setTimeout(()=> {

        try{
          this.cb.checked = allSelected

        }catch{}
      
      }
        , 500)
      this.cdr.detectChanges()
    })

    // setTimeout(()=> this.cb.checked = allSelected, 500)

    

  }


  isAllSelected(): boolean {

    switch (this.currentTable) {
      case 'Library': {
        if (this.libraryData)
          return this.libraryData.data.every(row => row.checked)
      }
      case 'Category': {
        if (this.categoryData) {
          return this.categoryData.data.every(row => row.checked)
        }
      }
      case 'Territory': {
        if (this.territoryData)
          return this.territoryData.data.every(row => row.checked)
      }
    }
    return false;
  }

  shouldDisable(row = null): boolean {
    switch (this.currentTable) {
      case 'Territory': {

      try{
        if(this.territoryChanges.length> 0){
          return false;
        }else{
          if(this.territoryData){
            return this.territoryData.data.every(x=> x.checked == true) 
            && this.libraryData.data.find(x=> x.id == this.territoryData.data[0].parentID).checked
          }else{
            return false
          }
        }
      }catch{
        
      }
      }
      case 'Category': {

        if(this.categoryChanges.length > 0){
          return false;
        }else{
          if(this.categoryData){
            return this.categoryData.data.every(x=> x.checked == true)
            && (this.territoryData && this.territoryData.data.length >0 ? 
              this.territoryData.data.find(x=> x.id == this.categoryData.data[0].parentID).checked : 
              this.libraryData.data.find(x=> x.id == this.categoryData.data[0].parentID).checked)
          }else{
            return false
          }
        }
      }
    }
  }


  goBack() {
    switch (this.currentTable) {

      case 'Library': {
        this.dialogRef.close();
        break;
      }

      case 'Territory': {
        this.changeTable('Library', this.parentId);
        break;
      }


      case 'Category': {

        if(!this.skipFolder){
          this.changeTable('Territory', this.parentId);
        }else{
          this.changeTable('Library', this.parentId);
        }
        break;
      }

    }

  }

  changeTable(table: string, folderId?: any) {
    switch (table) {
      case 'Library': {


        this.currentTable = table;
        this.permissions = `${table} Permissions`

        this.permissionsDetail = `Please select which libraries you want to grant ${this.accessType} permissions.\n
        This will grant permissions to all sub-folders`

        this.getInitialData(true)
        break;
      }
      case 'Territory': {

        if (this.libraryChanges.length > 0) {
          this._snackBar.open('Cannot navigate to saving changes', 'Dismiss')
          break;
        }

        this._snackBar.dismiss()

        this.currentTable = table;
        this.permissions = `${table} Permissions`

        this.permissionsDetail = `Please select which territories you want to grant ${this.accessType} permissions.\n
        This will grant permissions to all sub-folders for`


        this.getTerritoryData(folderId, true)
        break;
      }
      case 'Category': {

        if (this.territoryChanges.length > 0) {
          this._snackBar.open('Cannot navigate without saving changes ', 'Dismiss')
          break;
        }

        this._snackBar.dismiss()

        this.currentTable = table;
        this.permissions = `${table} Permissions`

        this.permissionsDetail = `Please select which categories you want to grant ${this.accessType} permissions.\n
        This will grant permissions to all documents for `
        this.getCategoryData(folderId, true)
        break;
      }

    }
  }

  onPageOptionsChange(e: any) {
    switch (this.currentTable) {
      case 'Library': {
        this.getInitialData();
        break;
      }
      // case 'Category': {

      //   this.getCategoryData(this.catFolderId, false)
      //   break;
      // }
      // case 'Territory': {
      //   this.getTerritoryData(this.terFolderId, false)
      //   break;
      // }
    }

    this.cdr.detectChanges()
  }

  onSelectAllStateChanged(row: Folder & { checked?: boolean }) {


    switch (this.currentTable) {
      case 'Library': {
        if (!this.libraryChanges.find(x => row.id == x.id) && row.checked != this.currentLibraryState.find(x => x.id == row.id).checked) {
          this.libraryChanges.push(row)
        } else {
          const index = this.libraryChanges.findIndex(x => x.id == row.id);

          if (index !== -1 && row.checked == this.currentLibraryState.find(x => x.id == row.id).checked) {
            this.libraryChanges.splice(index, 1)
          }
        }

        break;
      }
      case 'Territory': {
        if (!this.territoryChanges.find(x => row.id == x.id) && row.checked != this.currentTeritoryState.find(x => x.id == row.id).checked) {
          this.territoryChanges.push(row)
        } else {
          const index = this.territoryChanges.findIndex(x => x.id == row.id);

          if (index !== -1 && row.checked == this.currentTeritoryState.find(x => x.id == row.id).checked) {
            this.territoryChanges.splice(index, 1)
          }
        }
        break;
      }
      case 'Category': {
        if (!this.categoryChanges.find(x => row.id == x.id) && row.checked != this.currentCategoryState.find(x => x.id == row.id).checked) {
          this.categoryChanges.push(row)
        } else {
          const index = this.categoryChanges.findIndex(x => x.id == row.id);

          if (index !== -1 && row.checked == this.currentCategoryState.find(x => x.id == row.id).checked) {
            this.categoryChanges.splice(index, 1)
          }
        }
        break;
      }
    }

  }


  onStateChanged(row: Folder & { checked?: boolean }) {

    switch (this.currentTable) {
      case 'Library': {
        let var1 = this.libraryChanges.find(x => x.id == row.id)
        if (var1) {
          if (var1.checked != this.previousRowState.checked && this.previousData.find(x => x.id == row.id).checked != var1.checked) {
            this.libraryChanges.push(row)
          } else {
            const index = this.libraryChanges.findIndex(x => x.id == row.id)

            this.libraryChanges.splice(index, 1)
          }
        } else {
          this.libraryChanges.push(row)
        }
        break;
      }
      case 'Territory': {
        let var1 = this.territoryChanges.find(x => x.id == row.id)
        if (var1) {
          if (var1.checked != this.previousRowState.checked && this.previousData.find(x => x.id == row.id).checked != var1.checked) {
            this.territoryChanges.push(row)
          } else {
            const index = this.territoryChanges.findIndex(x => x.id == row.id)

            this.territoryChanges.splice(index, 1)
          }
        } else {
          this.territoryChanges.push(row)
        }
        break;
      }
      case 'Category': {
        let var1 = this.categoryChanges.find(x => x.id == row.id)
        if (var1) {
          if (var1.checked != this.previousRowState.checked && this.previousData.find(x => x.id == row.id).checked != var1.checked) {
            this.categoryChanges.push(row)
          } else {
            const index = this.categoryChanges.findIndex(x => x.id == row.id)

            this.categoryChanges.splice(index, 1)
          }
        } else {
          this.categoryChanges.push(row)
        }
        break;
      }
    }
  }


  onStateChanging(row: Folder & { checked?: boolean }) {
    this.previousRowState = { ...row }

    switch (this.currentTable) {
      case 'Library': {
        this.previousData = [...this.libraryData.data]
        break;
      }
      case 'Territory': {
        this.previousData = [...this.territoryData.data]
        break;
      }
      case 'Category': {
        this.previousData = [...this.categoryData.data]
        break;
      }

    }


  }


  save() {

    let allChanges;
    if (this.libraryChanges.length > 0) {

      const changes = this.libraryChanges.map(x => {
        const updatedObject = { ...x };

        if (!updatedObject.checked) {
          const aclCopy = [...updatedObject.acl]; // Create a copy of the `acl` array
          const index = aclCopy.findIndex(y => y.name === this.user);
          if (index !== -1) {
            aclCopy.splice(index, 1);
          }
          updatedObject.acl = aclCopy; // Assign the updated array back to the object
        } else {

          const aclCopy = [...updatedObject.acl]; // Create a copy of the `acl` array
          const index = aclCopy.findIndex(y => y.name === this.user);
          if (index !== -1) {
            aclCopy.splice(index, 1);
          }
          updatedObject.acl = [
            ...aclCopy,
            { direct: true, temporary: false, level: this.accessType === 'READER' ? 'Read' : 'Initiator', name: this.user }
          ];
        }

        delete updatedObject.checked;
        delete updatedObject.propertiesObj;
        updatedObject.objectStore =this.data.objectStore

        return updatedObject;
      });

      if (allChanges) {
        allChanges = [...changes, allChanges]

      } else {
        allChanges = [...changes]
      }

    }

    if (this.categoryChanges.length > 0) {
      const changes = this.categoryChanges.map(x => {
        const updatedObject = { ...x };

        if (!updatedObject.checked) {
          const aclCopy = [...updatedObject.acl]; // Create a copy of the `acl` array
          const index = aclCopy.findIndex(y => y.name === this.user);
          if (index !== -1) {
            aclCopy.splice(index, 1);
          }
          updatedObject.acl = aclCopy; // Assign the updated array back to the object
        } else {
          updatedObject.acl = [
            ...updatedObject.acl,
            { direct: true, temporary: false, level: this.accessType === 'READER' ? 'Read' : 'Initiator', name: this.user }
          ];
        }

        delete updatedObject.checked;
        delete updatedObject.propertiesObj;
        updatedObject.objectStore = this.data.objectStore

        return updatedObject;
      });

      if (allChanges) {
        allChanges = [...changes, ...allChanges]

      } else {
        allChanges = [...changes]
      }
    }

    if (this.territoryChanges.length > 0) {
      const changes = this.territoryChanges.map(x => {
        const updatedObject = { ...x };

        if (!updatedObject.checked) {
          const aclCopy = [...updatedObject.acl]; // Create a copy of the `acl` array
          const index = aclCopy.findIndex(y => y.name === this.user);
          if (index !== -1) {
            aclCopy.splice(index, 1);
          }
          updatedObject.acl = aclCopy; // Assign the updated array back to the object
        } else {
          updatedObject.acl = [
            ...updatedObject.acl,
            { direct: true, temporary: false, level: this.accessType === 'READER' ? 'Read' : 'Initiator', name: this.user }
          ];
        }

        delete updatedObject.checked;
        delete updatedObject.propertiesObj;
        updatedObject.objectStore = this.data.objectStore

        return updatedObject;
      });



      if (allChanges) {
        allChanges = [...changes, allChanges]

      } else {
        allChanges = [...changes]
      }


    }

    this.dontShow = true;

    this.loadingSave$.next(true)
    const observables = allChanges.map(change => this.folderService.update(change));
    let count = 1;

    forkJoin(observables.map(
      o => o.pipe(
        tap(() => {
          this.progressMessage = `${count} of ${observables.length} completed`
          count++;
        })
      )
    )).subscribe(
      () => {
        this.loadingSave$.next(false)
        this._snackBar.open("User permissions updated successfully", "Dismiss");

        this.libraryChanges = []
        this.categoryChanges = []
        this.territoryChanges = []

        this.dontShow = false

      },
      () => {
        this.loadingSave$.next(true)
        this._snackBar.open("An error occurred while updating user permissions", "Dismiss");

        this.libraryChanges = []
        this.categoryChanges = []
        this.territoryChanges = []
        this.dontShow = false
        this.dialogRef.close()
      }
    );



  }

  canSave(): boolean {


    if (this.libraryChanges.length > 0 || this.categoryChanges.length > 0 || this.territoryChanges.length > 0) {
      return false;
    }

    return true;
  }

  backDisabled(): boolean {

    switch (this.currentTable) {
      case 'Category': {

        if (this.categoryChanges.length > 0) {
          return true;
        }
        break;
      }
      case 'Territory': {
        if (this.territoryChanges.length > 0) {
          return true;
        }
        break;
      }
    }

    return false;
  }




}










